import React from 'react'
import styled, { css } from 'styled-components'

import { media } from '../../styles/utils'
import { container, bgIcon, padding, hoverState } from '../../styles/global'
import { resolveBlock } from './utils';

const Block = (props) => {
	const { layout, lastBlock, lastTextBlock, caseStudies } = props;
	const BlockLayout = resolveBlock(layout);

	if (!BlockLayout) return <></>

	return (
		<Wrapper
			className={`block_${layout}`}
			layout={layout}
			blockProps={props}
			styles={BlockLayout && BlockLayout.wrapper}
			lastBlock={lastBlock}
			lastTextBlock={lastTextBlock}
			caseStudies={caseStudies}
		>
			{BlockLayout && (
				<BlockLayout {...props}/>
			)}
		</Wrapper>
	)
}

const Wrapper = styled.div`
    width: 100%;
	margin-bottom: 4rem;
	
	/* Block specific container styles */

	${props => {
		if (props.styles) return props.styles
	}}
/* 
	${props => {
		if (props.lastBlock)
			return css`
				margin-bottom: 0;
			`
	}} */
`

export default Block